// extracted by mini-css-extract-plugin
export default {"entityCompleteIcon":"CrEntityCompleteIcon_entityCompleteIcon__mv14M"};